"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconActionPlus = function IconActionPlus(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M38 23H27V12H23V23H12V27H23V38H27V27H38V23Z",
    fill: color
  }));
};

IconActionPlus.defaultProps = {
  color: 'black',
  size: 30
};
IconActionPlus.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconActionPlus;
exports.default = _default;